import * as Sentry from '@sentry/react';

import { env } from './env';

export function initSentry(): void {
  if (!env.sentryDsn) {
    return;
  }

  Sentry.init({
    dsn: env.sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    environment: import.meta.env.MODE,
    release: 'waf-crm@0.1.0',
    tracesSampleRate: env.sentryTracesSampleRate,
    sendDefaultPii: false,
  });
}
